import { render, staticRenderFns } from "./CustomHtml.vue?vue&type=template&id=1d2a60d6"
import script from "./CustomHtml.vue?vue&type=script&lang=js"
export * from "./CustomHtml.vue?vue&type=script&lang=js"
import style0 from "./CustomHtml.vue?vue&type=style&index=0&id=1d2a60d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports